import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
// @mui
import {

  Stack,
  Paper,

  Button,

  Container,
  Typography,

  Grid,
  CircularProgress,

  Box,
  TextField,
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';

import {

  EditClientNotes,
  GetClient,

} from 'src/components/services/httpServices';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function ClientNotes(props) {
  let { id } = useParams();
  const navigate = useNavigate();

  const [client, setClient] = useState({});
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');

  const notesRef = useRef('');
  const fetchClient = async (event) => {
    const savedclient = await GetClient(id);
    setClient(savedclient);
    setLoading(false);
  };
  useEffect(() => {
    fetchClient();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const SaveClient = async (event) => {
    setLoading(true);
    // setPosting(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      id: id,
      clientNotes: notesRef.current.value,
    };

    //console.log(payload);
    let response = await EditClientNotes(payload);
   // console.log('PostResponse:', response);

    if (response.status == 200) {
      props.setMessage('Client saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      setLoading(false);

      let clientSaved = response.data;

      setClient(clientSaved);
    } else {
      setLoading(false);
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
    }
  };

  return (
    <>
      <form onSubmit={SaveClient}>
        <Helmet>
          <title> Clients | Immigration System </title>
        </Helmet>
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom></Typography>

            <Stack direction="row" spacing={2}>
              {/* <Button
                onClick={() => {
                  navigate(-1);
                }}
                variant="contained"
              >
                Back
              </Button> */}
              <Button type="submit" variant="contained">
                Save
              </Button>
            </Stack>
          </Stack>
          {loading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
              <CircularProgress size={60} thickness={3} value={100} />
            </Grid>
          ) : (
            <Box
              p={4}
              component={Paper}
              boxShadow={3}
              sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4} md={12}>
                  <TextField
                    label="Notes"
                    required
                    variant="outlined"
                    multiline
                    defaultValue={client?.clientNotes}
                    rows={10}
                    fullWidth
                    size="small"
                    inputRef={notesRef}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </Container>
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </form>
    </>
  );
}
